export const iconFontAwesomeHouseholdBoxTissue = (
	<i className="fa-solid fa-box-tissue"></i>
);
